export default __webpack_public_path__ + "static/media/arte.94f64044.svg";